/*
 * Frees localStorage from old sofa previews.
 *
 * The configurator asset stores a screenshot of every sofa added to the cart under its `_set_id` (a UUID), as a
 * data: URL, and nothing ever removed them. A few hundred KB each, so after enough sofas localStorage is full, the
 * next setItem throws (caught and ignored) and the cart card shows no picture of the new sofa.
 *
 * Loaded on /cart and on the configurator page: removes every UUID-keyed image that belongs to no line of the
 * current cart. The candidate keys are read BEFORE /cart.js is fetched, so a preview written meanwhile (a sofa being
 * added right now) is never among them.
 */
(() => {
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  let candidates = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && UUID.test(key)) candidates.push(key);
    }
  } catch (error) {
    return;
  }
  if (!candidates.length) return;

  fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, { credentials: "same-origin" })
    .then((response) => (response.ok ? response.json() : null))
    .then((cart) => {
      if (!cart) return;
      const inCart = new Set();
      for (const item of cart.items || []) {
        const setId = item.properties?._set_id || item.properties?._set;
        if (setId) inCart.add(setId);
      }
      for (const key of candidates) {
        if (inCart.has(key)) continue;
        try {
          const value = localStorage.getItem(key);
          if (value && value.startsWith("data:image")) localStorage.removeItem(key);
        } catch (error) {
          /* storage unavailable — nothing to free */
        }
      }
    })
    .catch(() => {});
})();
